<template>
  <div class="main">
    <topImg
      title="客户案例"
      img="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/gaozhi/banner_anli.png"
    ></topImg>
    <div class="content">
      <div id="pageChange"></div>
      <el-tabs
        v-model="tabSelected"
        @tab-click="tabChange"
        style="margin-top: 60px"
      >
        <!-- <el-tab-pane label="高职客户案例"></el-tab-pane>
        <el-tab-pane label="K12客户案例"></el-tab-pane> -->
      </el-tabs>
      <div class="newList">
        <div class="new" v-for="item in list" :key="item.id">
          <div class="bgimg">
            <img v-lazy="item.thumb" :key="item.thumb" />
          </div>
          <div class="newTitle">{{ item.title }}</div>
          <span class="line"></span>
          <div class="desc">{{ item.description }}</div>
          <div class="model">
            <div class="title">{{ item.title }}</div>
            <div class="line"></div>
            <div class="desc">{{ item.description }}</div>
          </div>
        </div>
      </div>
      <div class="pagination" v-if="list.length > 0" id="isPCF">
        <el-pagination
          :background="true"
          layout="prev, pager, next"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          :total="total"
        >
        </el-pagination>
      </div>
      <van-pagination
        id="isMobileF"
        class="paginationMobile"
        @change="handleCurrentChange"
        v-model="currentPage"
        :total-items="total"
        items-per-page="12"
      />
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { Pagination } from 'vant';
import { caseList } from '@/services/api';

Vue.use(Pagination);

export default {
  data() {
    return {
      tabSelected: 0,
      total: 0,
      currentPage: 1,
      //   pageTotal: 0,
      pageSize: 12,
      list: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
      window.location.href = '#pageChange';
    },
    tabChange(tab) {
      this.tabSwlected = tab.index;
      this.currentPage = 1;
      this.getData();
    },
    getData() {
      let data = {
        page: this.currentPage,
        page_size: this.pageSize,
        catid: this.tabSelected == 0 ? 21 : 22
      };
      caseList(data).then(res => {
        this.list = res.data.list;
        this.total = res.data.total;
      });
    }
  }
  //   watch: {
  //     tabSwlected(tab) {
  //       console.log('change', tab)
  //       if (tab === 0) {
  //         this.getHighList()
  //       } else {
  //         this.getK12List()
  //       }
  //     }
  //   }
};
</script>
<style lang="less" scoped>
.main {
  background: #fff;
  .content {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 100px;
    .newList {
      width: 100%;
      margin-top: 50px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      .new {
        width: 31.6666%;
        height: 430px;
        margin-bottom: 30px;
        border-top-left-radius: 19px;
        border-top-right-radius: 19px;
        display: flex;
        flex-direction: column;
        position: relative;
        .bgimg {
          width: 100%;
          height: 263px;
          margin-bottom: 21px;
          border-top-left-radius: 19px;
          border-top-right-radius: 19px;
          img {
            width: 100%;
            height: 263px;
            border-top-left-radius: 19px;
            border-top-right-radius: 19px;
          }
        }
        .newTitle {
          color: #000;
          height: 30px;
          font-size: 22px;
          font-weight: 550;
          line-height: 30px;
          padding: 0 29px;
          overflow: hidden;
          margin-bottom: 7px;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
        }
        .line {
          width: 27px;
          height: 4px;
          background-color: #ef623d;
          display: inline-block;
          border-radius: 2px;
          margin: 0 29px 10px 29px;
        }
        > .desc {
          height: 66px;
          color: #000;
          font-size: 14px;
          line-height: 22px;
          padding: 0 29px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
        }
        .model {
          width: 100%;
          height: auto;
          position: absolute;
          padding-bottom: 50px;
          bottom: 0;
          z-index: 2;
          background: linear-gradient(
            180deg,
            rgba(246, 140, 68, 0.8) 0%,
            rgba(233, 100, 61, 99%) 30%,
            #ef623d 100%
          );

          box-shadow: 0px 0px 10px -2px rgba(133, 133, 133, 0.66);
          border-radius: 19px;
          opacity: 0;
          transition: all 0.3s;
          .line {
            background-color: #fff;
          }
          .title {
            color: #fff;
            padding: 0 29px;
            margin-top: 25px;
            font-size: 22px;
            font-weight: bold;
          }
          .desc {
            color: #fff;
            margin-top: 4px;
            font-size: 14px;
            font-weight: 400;
            color: #ffffff;
            line-height: 25px;
            padding: 0 29px;
          }
        }
      }
      .new:hover .model {
        opacity: 1;
      }
    }
    .pagination {
      display: flex;
      // justify-content: space-between;
      justify-content: center;
      align-items: center;
      margin-top: 33px;
      .desc {
        span {
          color: #666666;
          font-size: 13px;
          font-weight: 400;
          color: #666666;
          line-height: 17px;
        }
        span:nth-child(2) {
          color: #f27529;
        }
      }
      /deep/ .el-pager li.active {
        color: #f27529;
        cursor: default;
      }
      /deep/ .el-pager li:hover {
        color: #f27529;
      }
    }
    // 修改tab分页标签组件样式
    /deep/.el-tabs__item {
      width: 150px;
      padding: 0;
      color: #6b738c;
      text-align: center;
      border-radius: 20px;
    }
    /deep/.el-tabs__nav {
      border-radius: 20px;
      background-color: #efefef;
    }
    /deep/.el-tabs__item:hover {
      color: #6b738c;
    }
    /deep/.el-tabs__item.is-active,
    /deep/.el-tabs__item.is-active:hover {
      color: #fff;
      background: #f27529 !important;
    }
    /deep/.el-tabs__active-bar,
    /deep/.el-tabs__nav-wrap::after {
      height: 0;
    }
    // 修改页面分页组件样式
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      color: #fff;
      border: 0;
      background: #f27529 !important;
    }
  }
}
@media (max-width: 1000px) {
  .main {
    .content {
      width: 100%;
      padding: 0 48px 80px;
      box-sizing: border-box;
      /deep/.el-tabs__item {
        width: 120px;
        font-size: 28px;
      }
      .newList {
        margin-top: 30px;
        flex-direction: column;
        .new {
          width: 100%;
          height: auto;
          margin-bottom: 40px;
          .bgimg {
            height: 280px;
            img {
              height: 280px;
            }
          }
          .newTitle {
            font-size: 28px;
            padding: 0 20px;
            height: auto;
            -webkit-line-clamp: 2;
          }
          .line {
            margin: 8px 20px 10px 20px;
          }
          > .desc {
            font-size: 24px;
            line-height: 36px;
            height: auto;
            -webkit-line-clamp: 3;
            padding: 0 20px;
          }
          .model {
            display: none;
          }
        }
        .new:hover .model {
          opacity: 0;
        }
      }
      .paginationMobile {
        width: 90%;
        margin: 0 auto;
      }
      /deep/ .van-pagination__item {
        color: #F27529;
      }
      /deep/ .van-pagination__item--active {
        color: #fff;
        background: #f27529;
      }
    }
  }
}
</style>
